import { buildRouteHead } from "@/lib/seo/routeHead";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/es/centro-de-conocimiento")({
  head: () => buildRouteHead("/es/centro-de-conocimiento", { noIndex: true }),
  beforeLoad: () => {
    throw redirect({ to: "/es/recursos", replace: true });
  },
});
